export const pathwayStatuses = {
    active: 0,
    completed: 1,
};
